/**
 * @fileoverview Icons for the day-one primary-contact modes (MOR-2342).
 *
 * The labels live server-side in `convex/jobs/precedents/contactPerson.ts`
 * so the wizard, settings card and tests share one wording; the icons are
 * client-only and live here. Typed as a `Record` over the mode union so a
 * new mode without an icon fails the build.
 */

import type { LucideIcon } from "lucide-react";
import {
  Award,
  BookUser,
  BriefcaseBusiness,
  UserCheck,
  UserPen,
} from "lucide-react";
import type { DayOneContactDefaultMode } from "@cvx/organizations/schema";

export const CONTACT_PERSON_MODE_ICONS: Record<
  DayOneContactDefaultMode,
  LucideIcon
> = {
  firm_preset: BookUser,
  preparing_user: UserPen,
  appointee: Award,
  staff_member: UserCheck,
  job_role: BriefcaseBusiness,
};

/** Every mode in display order, shared by the settings card and the wizard. */
export const CONTACT_PERSON_MODES: ReadonlyArray<DayOneContactDefaultMode> = [
  "firm_preset",
  "preparing_user",
  "appointee",
  "staff_member",
  "job_role",
];
